/**
 * Gets the computed transition-duration CSS property of the given element in millisecond unit.
 * If multiple durations are set, then it gets the maximum value.
 * @param {*} element - The DOM element to get transition duration from.
 */
const getElementTransitionDuration = (element: HTMLElement) => {

	if (!element) {

		return 0;

	}

	const cssTransitionDuration = window.getComputedStyle(element).transitionDuration;
	const durations = cssTransitionDuration ? cssTransitionDuration.split(',') : null;

	if (!durations || (durations.length === 1 && parseFloat(durations[0]) === 0)) {

		return 0;

	}

	const isUnitMs = cssTransitionDuration.indexOf('ms') !== -1;
	return durations.reduce((prevMax, curr) => {

		let duration = parseFloat(curr);
		if (!isUnitMs) {

			duration *= 1000;

		} else if (duration % 1 !== 0) {

			duration = Math.ceil(duration);

		}

		return Math.max(prevMax, duration);

	}, 0);

};

export default getElementTransitionDuration;
